"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLE_SETTINGS = exports.STYLE_SETTINGS_KEY = exports.NEW_TO_OLD_STYLE_KEYS_MAP = exports.BUTTON_FONT_COLOR = exports.BUTTON_BACKGROUND_COLOR = exports.FONT_COLOR = exports.SUBMIT_ALIGNMENT = exports.SUBMIT_COLOR = exports.SUBMIT_FONT_COLOR = exports.LABEL_TEXT_COLOR = exports.LABEL_TEXT_SIZE = exports.FONT_FAMILY = exports.CREATE_EMAILLESS_CONTACT_KEY = exports.FORM_CREATE_EMAILLESS_CONTACT_ENABLED = exports.FORM_SETTINGS = exports.FORM_SETTING_PREFIX = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _NEW_TO_OLD_STYLE_KEY;

var FORM_SETTING_PREFIX = 'Forms:';
exports.FORM_SETTING_PREFIX = FORM_SETTING_PREFIX;
var FORM_SETTINGS = 'FormSettings';
exports.FORM_SETTINGS = FORM_SETTINGS;
var FORM_CREATE_EMAILLESS_CONTACT_ENABLED = 'formsCreateEmaillessContactEnabled';
exports.FORM_CREATE_EMAILLESS_CONTACT_ENABLED = FORM_CREATE_EMAILLESS_CONTACT_ENABLED;
var CREATE_EMAILLESS_CONTACT_KEY = FORM_SETTING_PREFIX + "CreateContactWithoutEmail"; // New Keys

exports.CREATE_EMAILLESS_CONTACT_KEY = CREATE_EMAILLESS_CONTACT_KEY;
var FONT_FAMILY = 'fontFamily';
exports.FONT_FAMILY = FONT_FAMILY;
var LABEL_TEXT_SIZE = 'labelTextSize';
exports.LABEL_TEXT_SIZE = LABEL_TEXT_SIZE;
var LABEL_TEXT_COLOR = 'labelTextColor';
exports.LABEL_TEXT_COLOR = LABEL_TEXT_COLOR;
var SUBMIT_FONT_COLOR = 'submitFontColor';
exports.SUBMIT_FONT_COLOR = SUBMIT_FONT_COLOR;
var SUBMIT_COLOR = 'submitColor';
exports.SUBMIT_COLOR = SUBMIT_COLOR;
var SUBMIT_ALIGNMENT = 'submitAlignment'; // Old Keys

exports.SUBMIT_ALIGNMENT = SUBMIT_ALIGNMENT;
var FONT_COLOR = 'fontColor';
exports.FONT_COLOR = FONT_COLOR;
var BUTTON_BACKGROUND_COLOR = 'buttonBackgroundColor';
exports.BUTTON_BACKGROUND_COLOR = BUTTON_BACKGROUND_COLOR;
var BUTTON_FONT_COLOR = 'buttonFontColor'; // New to Old Keys - Remove once migrated.

exports.BUTTON_FONT_COLOR = BUTTON_FONT_COLOR;
var NEW_TO_OLD_STYLE_KEYS_MAP = (_NEW_TO_OLD_STYLE_KEY = {}, (0, _defineProperty2.default)(_NEW_TO_OLD_STYLE_KEY, LABEL_TEXT_COLOR, FONT_COLOR), (0, _defineProperty2.default)(_NEW_TO_OLD_STYLE_KEY, SUBMIT_FONT_COLOR, BUTTON_FONT_COLOR), (0, _defineProperty2.default)(_NEW_TO_OLD_STYLE_KEY, SUBMIT_COLOR, BUTTON_BACKGROUND_COLOR), _NEW_TO_OLD_STYLE_KEY);
exports.NEW_TO_OLD_STYLE_KEYS_MAP = NEW_TO_OLD_STYLE_KEYS_MAP;
var STYLE_SETTINGS_KEY = FORM_SETTING_PREFIX + "Style";
exports.STYLE_SETTINGS_KEY = STYLE_SETTINGS_KEY;
var STYLE_SETTINGS = {
  FONT_FAMILY: FONT_FAMILY,
  LABEL_TEXT_COLOR: LABEL_TEXT_COLOR,
  LABEL_TEXT_SIZE: LABEL_TEXT_SIZE,
  SUBMIT_FONT_COLOR: SUBMIT_FONT_COLOR,
  SUBMIT_COLOR: SUBMIT_COLOR,
  SUBMIT_ALIGNMENT: SUBMIT_ALIGNMENT
};
exports.STYLE_SETTINGS = STYLE_SETTINGS;